/*
 * @Description: 
 * @Author: dezhi
 * @Date: 2019-08-26 09:11:29
 * @LastEditTime: 2021-06-18 14:12:46
 * @LastEditors: zhaoshuai
 */
// const api2 = 'http://192.168.4.40:26040/v1.0.0/';
// const api2 = 'http://192.168.4.110:26040/v1.0.0/';
// axios.defaults.headers.common['X_AUTH_TOKEN'] = localStorage.getItem("token");
import axios from 'axios';

const state = {
    userInfo: {},
    token: '',
    loginStatus: false,
    loginId: "",
}

// getters
const getters = {

}

// actions
const actions = {
    async getStudentInfo({ commit }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/enrollInfo/getEnrollInfoDetails?orderCode=${payload.orderCode}&userCode=${payload.userCode}&examCode=${payload.examCode}`)
        localStorage.setItem('studentInfo', JSON.stringify(res.data.data))
        commit('saveStudentInfo', res.data.data)
        return res;
    },
    /**
     * @description: 用户的账号密码登录
     * @param {type} 
     * @return: 
     */
    async accountLoginAction({ commit }, payload) {
        const res = await axios.post('/v1.0.0/user/examuser/examLogin/1', payload)
        if (res.data.status == 2000) {
            let data = res.data.data;
            // 设置用户id和token到cookie
            commit('login', {
                userInfo: data.userInfo,
                token: data.token,
                secondUser:data.examEnrollInfoDto
            })

        }
        return res
    },

}

// mutations

const mutations = {
    saveStudentInfo(state, payload) {
        // state.classInfo = state.infoList[payload - 1];
        state.studentInfo = payload;
    },
    saveUserInfo(state, payload) {
        state.userInfo = payload
    },
    saveToken(state, payload) {
        state.token = payload
    },
    login(state, { token, userInfo,secondUser }) {
        state.loginStatus = true;
        state.userInfo = userInfo;
        localStorage.setItem('apply_token', token)
        localStorage.setItem('loginStatus', true)
      
            localStorage.setItem('second_userInfo', JSON.stringify(secondUser))
     
            localStorage.setItem('apply_userInfo', JSON.stringify(userInfo))
      
        
    },
    logout(state) {
        state.loginStatus = false;
        state.userInfo = {};
        localStorage.setItem('apply_token', '')
        localStorage.setItem('loginStatus', false)
        localStorage.setItem('apply_userInfo', '')
        localStorage.setItem('second_userInfo', '')
    },
    setLoginId(state, loginId) {
        state.loginId = loginId;
    },
    setLoginStatus(state, status) {
        state.loginStatus = status;
    }
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}